import classNames from 'classnames';
import React from 'react';
import styles from './topLabel.module.scss';
export var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["CLOUD"] = "cloud";
    BackgroundColor["FOG"] = "fog";
})(BackgroundColor || (BackgroundColor = {}));
export var InputVariantEnum;
(function (InputVariantEnum) {
    InputVariantEnum["DEFAULT"] = "default";
    InputVariantEnum["LABEL_OUTSIDE"] = "label-outside";
})(InputVariantEnum || (InputVariantEnum = {}));
export const DEFAULT_INPUT_VARIANT = InputVariantEnum.DEFAULT;
const TopLabel = ({ className, label, focused, hasValue, disabled, backgroundColor, isError, hideFromSRWhenInactive = false, variant = InputVariantEnum.DEFAULT, }) => {
    if (!label || (hideFromSRWhenInactive && !focused && !hasValue)) {
        return null;
    }
    const srOnly = {
        [InputVariantEnum.DEFAULT]: !focused && !hasValue,
        [InputVariantEnum.LABEL_OUTSIDE]: false,
    };
    return (<span className={classNames({
            [styles.label]: variant === InputVariantEnum.DEFAULT,
            [styles.labelOutside]: variant === InputVariantEnum.LABEL_OUTSIDE,
            [styles.disabled]: disabled,
            [styles.cloudLabel]: backgroundColor === BackgroundColor.CLOUD,
            [styles.fogLabel]: backgroundColor === BackgroundColor.FOG,
            [styles.error]: isError,
            srOnly: srOnly[variant],
        }, className)}>
      {label}
    </span>);
};
export default TopLabel;
